import * as LabelPrimitive from '@radix-ui/react-label';
import * as React from 'react';

import { cn } from '../cn';

/** Form label — DESIGN.md §5 "Inputs / Fields": label above the field, never placeholder-as-label. */
export const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      'text-label font-medium text-ink peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
      className,
    )}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;
